import { Routes } from '@angular/router';

export const routes: Routes = [

    {
        path: 'career',
        loadChildren: () => import('./career/career-routes').then(m => m.CAREER_ROUTES)
    },
       {
        path: 'candidate',
        loadChildren: () => import('./outreach/outreach.routes').then(m => m.OUTREACH_ROUTES)
    },
    {
        path: 'demo',
        loadComponent: () => import('./demo/demo').then(c => c.Demo)
    },
    { path: '', redirectTo: 'career', pathMatch: 'full' },
    {path: '**', loadComponent: () => import('./not-found/not-found').then(c => c.NotFound) }
];

